import { render } from "./QualificationLanguage.vue?vue&type=template&id=486166ad"
import script from "./QualificationLanguage.vue?vue&type=script&lang=js"
export * from "./QualificationLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__